var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOldage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2a7bfe",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "80px",
    height: "80px",
    viewBox: "0 0 300 300",
    enableBackground: "new 0 0 300 300",
    xmlSpace: "preserve",
    stroke: "#2a7bfe",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.111,33.896c0-12.979,10.521-23.5,23.5-23.5s23.5,10.521,23.5,23.5s-10.521,23.5-23.5,23.5 S147.111,46.875,147.111,33.896z M259.398,277.639c0,8.183-6.827,14.772-15.096,14.381c-7.494-0.354-13.579-6.646-13.698-14.148 c-0.1-6.292,3.844-11.662,9.396-13.722V216h-66v76h-10V177.16c0-20.303,14.149-37.352,33.101-41.837l-25.033-9.007 c-2.229-0.803-4.141-2.304-5.449-4.28l-19.381-29.289l-23.645,71.709l21.903,43.602c1.422,2.829,1.842,6.058,1.191,9.157 l-13.313,63.692c-1.587,7.568-9.008,12.416-16.575,10.829h0c-7.567-1.587-12.416-9.008-10.829-16.575l12.31-58.905L96.516,172.93 L66.25,281.779c-2.069,7.45-9.786,11.813-17.236,9.744h0c-7.45-2.069-11.812-9.785-9.744-17.236l36.99-133.061 c0.142-0.512,1.299-3.97,1.819-5.196l34.825-80.263c6.174-14.229,25.668-15.941,34.228-3.006l35.82,54.091l35.105,12.631 c5.716,2.057,8.683,8.358,6.626,14.075c-0.483,1.343-1.205,2.531-2.094,3.541C238.613,143.355,250,158.948,250,177.16v86.991 C255.483,266.185,259.398,271.448,259.398,277.639z M174.155,174h65.69c-1.596-16.719-15.715-29.839-32.845-29.839 S175.751,157.281,174.155,174z M240,206v-22h-66v22H240z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldage);
export default __webpack_public_path__ + "static/media/oldage.c5ba8f72d7839447b8e308a94bdac29f.svg";
export { ForwardRef as ReactComponent };